import { Modal } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";
import Cancelimg from "../../assets/img/cancel-01.svg";

const ClientIdentificationPendingErrorModal = ({
  show,
  onHide,
  errors = [],
}) => {
  const { _t } = useTranslator();

  return (
    <Modal
      className="wrapper-modal insurance-simulation-errors-modal"
      show={show}
      onHide={onHide}
      centered
      style={{ zIndex: 1053 }}
    >
      <Modal.Header>
        <Modal.Title>
          <div className="cursor-pointer" onClick={onHide}>
            <img
              src={Cancelimg}
              alt="icon"
              className="canceicon topRightIcon"
            />
          </div>
          <div className="d-flex align-items-center gap-3">
            <div className="d-flex align-items-center justify-content-center rounded-circle error-icon-bg">
              <img src="/images/red-error.svg" alt="Error" />
            </div>
            <div className="d-flex flex-column align-items-start error-modal-title-wrapper">
              <h5 className="mb-0 error-modal-title">
                {_t("amlSigningPending")}
              </h5>
              <p>
                {_t(
                  "requiredBeforeReportOrAward",
                  "Required before generating a report or awarding the property."
                )}
              </p>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="property-errors-main-container mb-2">
          <p className="property-errors-description">
            {_t(
              "completeAmlSigningBeforePropertyDecision",
              "The following tenants or guarantors must complete AML signing before you can continue."
            )}
          </p>
          <ul style={{ fontSize: "var(--text-13)" }}>
            {errors.map((error, index) => (
              <li
                className="d-flex align-items-start gap-6px insurance-error-row"
                key={`${error}-${index}`}
              >
                <img src="/images/red-error.svg" alt="Error" />
                <span className="insurance-error-text">{error}</span>
              </li>
            ))}
          </ul>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ClientIdentificationPendingErrorModal;
